<div (mouseleave)="close()" class="layout-column custom-panel full-width full-height">
  <div (click)="emitAction('REASSIGN_ROUTE')"
       [class.isActionDisabled]="isRouteDispatched || hasNotSyncedChanges"
       [ngbTooltip]="blockedActionTooltipKey | translate"
       container="body"
       openDelay="300"
       class="layout-row layout-align-start-center pointer padding-10 gap-5">
    <bringoz-icon iconName="allocation" class="gray-100"></bringoz-icon>
    <span class="flex br-body-2 font-weight-400 gray-100" translate>Reassign Route</span>
  </div>
</div>
